import Model from './BaseModel';

export default class ClassificationBetType extends Model {
	resourceName() {
		return 'classifications';
	}

	fields() {
		return ['product', 'bet_type', 'race_type', 'bonus_percentage'];
	}

	// override the base update for our request specific URL
	update(classificationId, data) {
		return this.makePersistRequest({
			url: `${this.resourceUrl()}${classificationId}/bet_types`,
			method: 'POST',
			data
		});
	}
}
